
import { Options, Vue } from 'vue-class-component';
import AppointmentService from "@/services/AppointmentService";
import { Region as RegionModel } from "@/data/region";
import { RecordIdentifier } from "@/data/global";
import { AppointmentEnrollmentStatusResponse } from "@/data/appointments";
import Alert from "@/components/Alert.vue";
import AppointmentEnrollment from "@/components/AppointmentEnrollment.vue";
import EventBusService from "@/services/EventBusService";
//import AuthService from "@/services/AuthService";
//import UrlService from "@/services/UrlService";

@Options({
    props: {
        appointmentId: {
            type: [Number, String],
            required: true,
        },
        regionId: {
            type: [Number, String],
            required: true,
        },
    },
    components: {
        AppointmentEnrollment,
        Alert,
    },
    emits: [
        'enrollmentStatusChange',
    ],
})
export default class AppointmentEnrollmentStatus extends Vue {
    appointmentId!: RecordIdentifier
    regionId!: RecordIdentifier

    loggedIn = false
    loginOpen = false

    error = false

    loading = true
    loaded = false

    enrollmentStatus: AppointmentEnrollmentStatusResponse|null = null

    get isEnrolledInAppointment() {
        return !!this.enrollmentStatus?.appointment;
    }
    get isEnrolledInCourse() {
        return !!this.enrollmentStatus?.course && this.enrollmentStatus?.course?.waiting === false;
    }
    get isWaitingForCourse() {
        return this.enrollmentStatus?.course?.waiting === true;
    }

    get showStatus() {
        return this.isEnrolledInCourse || this.isWaitingForCourse || this.isEnrolledInAppointment;
    }

    get courseIconClass() {
        return {
            'fa-check-circle': this.isEnrolledInCourse,
            'fa-clock': !this.isEnrolledInCourse && this.isWaitingForCourse,
            'fa-times-circle': !this.isEnrolledInCourse && !this.isWaitingForCourse,
            'text-success': this.isEnrolledInCourse,
            'text-warning': !this.isEnrolledInCourse && this.isWaitingForCourse,
            'text-danger': !this.isEnrolledInCourse && !this.isWaitingForCourse,
        };
    }
    get appointmentIconClass() {
        return {
            'fa-check-circle': this.isEnrolledInAppointment,
            'fa-times-circle': !this.isEnrolledInAppointment,
            'text-success': this.isEnrolledInAppointment,
            'text-danger': !this.isEnrolledInAppointment,
        };
    }

    onEnrollmentStatusChange() {
        this.loadEnrollmentStatus();
        this.$emit('enrollmentStatusChange');
    }

    loadEnrollmentStatus() {
        this.loading = true;
        return AppointmentService.getAppointmentEnrollmentStatus(this.appointmentId).then(result => {
            this.loggedIn = true;

            this.enrollmentStatus = result.data?.data || null;

            this.error = false;
            this.loaded = true;
        }).catch(error => {
            this.enrollmentStatus = null;
            if( error.response.status === 401 ) {
                this.loggedIn = false;
                return;
            }
            this.error = true;
        }).finally(() => this.loading = false);
    }

    mounted() {
        this.loadEnrollmentStatus();

        EventBusService.$on('user.credits:changed', this.loadEnrollmentStatus);
    }
    beforeUnmount() {
        EventBusService.$off('user.credits:changed', this.loadEnrollmentStatus);
    }
}
